import { fetchUtils } from 'react-admin';
import type { ClicksSummariesResource } from '../../../Entities/ClicksSummary';
import create from '../../create';
import type { JsonApiResource } from '../../JsonApiTypes';
import type { AuthProvider } from '../../AuthProvider';

export interface ReportClickSummaryCreateParams {
  from: string;
  to: string;
  granularity: 'daily' | 'hourly';
}
export interface ReportClickSummaryCreateResult {
  data: ClicksSummariesResource[];
  prefetched: Record<string, JsonApiResource[]>;
}
export type ReportClickSummaryCreate = (
  params: ReportClickSummaryCreateParams,
) => Promise<ReportClickSummaryCreateResult>;

export default function clickSummaryCreate(
  apiUrl: string,
  httpClient = fetchUtils.fetchJson,
  canAccess: typeof AuthProvider.canAccess = async () => true,
): ReportClickSummaryCreate {
  const createRecord = create(apiUrl, httpClient);
  return async (params) => {
    const prefetch = (await canAccess({ resource: 'clicks_summaries', action: 'list' }))
      ? ['results']
      : [];
    const result = await createRecord('reports', {
      data: {
        attributes: {
          report_type_id: 3,
          from: params.from,
          to: params.to,
          granularity: params.granularity,
        },
      },
      meta: { prefetch },
    });
    const prefetched = (result.meta?.prefetched ?? {}) as Record<string, JsonApiResource[]>;
    return { data: (prefetched.clicks_summaries ?? []) as ClicksSummariesResource[], prefetched };
  };
}
